module.exports = __webpack_public_path__ + "img/partners-ph.9cb4d3f.png";